import axios from "axios";

export const API_URL = "/api";
const PCLOUD_URL = "https://eapi.pcloud.com";

const sanitizeFileName = (name) =>
  name.replace(/[\\/:*?"<>|]/g, "_").slice(0, 100);

export const ServiceAPI = {
  getDigest: () => {
    return axios.get(`${PCLOUD_URL}/getdigest`, {
      headers: { user_authorization: undefined },
    });
  },

  createFolder: (_accessToken, folderId, folderName) => {
    return axios.get(
      `${PCLOUD_URL}/createfolderifnotexists?auth=${_accessToken}&folderid=${folderId}&name=${encodeURIComponent(folderName)}`,
      { headers: { user_authorization: undefined } }
    );
  },

  createService: (data) => {
    return axios.post(`${API_URL}/Service/createService`, data);
  },

  createVideoUpload: (data) => {
    return axios.put(`${API_URL}/Service/addUpload`, data);
  },

  upload_file: async (auth, folderId, file, fileName, setUploadProgress) => {
    if (!auth) throw new Error("Auth token nije definiran.");

    const safeFileName = sanitizeFileName(fileName || file.name);
    const uploadUrl = `${PCLOUD_URL}/uploadfile?auth=${auth}&nopartial=1&folderid=${folderId}&filename=${encodeURIComponent(safeFileName)}`;

    const formData = new FormData();
    formData.append("file", file, safeFileName);

    return axios.post(uploadUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        user_authorization: undefined,
      },
      onUploadProgress: (e) => {
        if (setUploadProgress && e.total) {
          const percent = Math.round((e.loaded * 100) / e.total);
          setUploadProgress(percent);
        }
      },
    });
  },

  login: () => {
    return axios.get(`${API_URL}/Service/getToken`);
  },

  listFolder: (_accessToken, folderId) => {
    return axios.get(
      `${PCLOUD_URL}/listfolder?auth=${_accessToken}&folderid=${folderId}`,
      { headers: { user_authorization: undefined } }
    );
  },

  getFileLink: (_accessToken, fileId) => {
    return axios.get(
      `${PCLOUD_URL}/getfilelink?auth=${_accessToken}&fileid=${fileId}`,
      { headers: { user_authorization: undefined } }
    );
  },
};